// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_f367f3', '__Inter_Fallback_f367f3'","fontStyle":"normal"},"className":"__className_f367f3"};